export const normalizeSLAOutputNumber = (value: number): number => {
  return parseFloat(value.toFixed(5));
};
